var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import images from "../../assets";
import * as S from "./FullScreenState2.styles";
import { EStateType } from "./FullScreenState2.types";
var FullScreenState = /** @class */ (function (_super) {
    __extends(FullScreenState, _super);
    function FullScreenState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FullScreenState.prototype.render = function () {
        var _a = this.props, title = _a.title, info = _a.info, stateType = _a.stateType, primaryActionTitle = _a.primaryActionTitle, secondaryActionTitle = _a.secondaryActionTitle, extraActionTitle = _a.extraActionTitle, onPressPrimaryAction = _a.onPressPrimaryAction, onPressSecondaryAction = _a.onPressSecondaryAction, onPressExtraAction = _a.onPressExtraAction;
        return (_jsxs(S.Wrap, { stateType: stateType, children: [_jsx(S.InnerWrap, { children: _jsxs(S.Circle1, { stateType: stateType, children: [_jsx(S.Circle2, { stateType: stateType, children: _jsx(S.Circle3, { stateType: stateType }) }), _jsxs(S.IconWrap, { children: [stateType === EStateType.Success && (_jsx(S.Icon, { source: images.ICO_CHECK_WHITE })), stateType === EStateType.Error && (_jsx(S.Icon, { source: images.ICO_CLOSE_WHITE })), stateType === EStateType.Loading && (_jsx(S.Icon, { source: images.ICO_LOADING_WHITE }))] })] }) }), _jsxs(S.BottomWrap, { children: [_jsx(S.Title, { children: title }), info && _jsx(S.Info, { children: info }), _jsxs(S.ButtonWrap, { children: [secondaryActionTitle && (_jsx(S.ButtonSecondaryStyled, { onPress: onPressSecondaryAction, title: secondaryActionTitle, isInverted: true })), primaryActionTitle && (_jsx(S.ButtonPrimaryStyled, { onPress: onPressPrimaryAction, title: primaryActionTitle }))] }), extraActionTitle && (_jsx(S.ExtraButton, { onPress: onPressExtraAction, title: extraActionTitle }))] })] }));
    };
    return FullScreenState;
}(React.PureComponent));
var FullScreenLoadingState = /** @class */ (function (_super) {
    __extends(FullScreenLoadingState, _super);
    function FullScreenLoadingState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.render = function () { return (_jsx(FullScreenState, __assign({}, _this.props, { stateType: EStateType.Loading }))); };
        return _this;
    }
    return FullScreenLoadingState;
}(React.PureComponent));
export { FullScreenLoadingState };
var FullScreenErrorState = /** @class */ (function (_super) {
    __extends(FullScreenErrorState, _super);
    function FullScreenErrorState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.render = function () { return (_jsx(FullScreenState, __assign({}, _this.props, { stateType: EStateType.Error }))); };
        return _this;
    }
    return FullScreenErrorState;
}(React.PureComponent));
export { FullScreenErrorState };
var FullScreenSuccessState = /** @class */ (function (_super) {
    __extends(FullScreenSuccessState, _super);
    function FullScreenSuccessState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.render = function () { return (_jsx(FullScreenState, __assign({}, _this.props, { stateType: EStateType.Success }))); };
        return _this;
    }
    return FullScreenSuccessState;
}(React.PureComponent));
export { FullScreenSuccessState };
// eslint-disable-next-line import/no-default-export
export default FullScreenState;
